import React, { memo, useState } from "react";

import { Modal, Button } from "react-bootstrap";
import InfoImage from "assets/images/info.png";

const NextModal = memo( function NextModal({
	isOpen, handler, submitResponse
}) {
	const [submitClick,setSubmitClick] = useState(true);
	const toggle = () => {
		handler(prev => false);
	};

	const submitAndShowNext = () => {
		if(submitClick){
			toggle();
			submitResponse();
			setSubmitClick(false);
			setTimeout(()=>{
				setSubmitClick(true);	
			},1000)
		}
	};

	return (
		// <Modal show={isOpen} size="sm" centered>
		// 	<Modal.Body>
		// 		<div>Do you want to go to next Question?</div>
		// 	</Modal.Body>

		// 	<Modal.Footer>
		// 		<Button
		// 			variant="secondary"
		// 			className="modalCloseBtn"
		// 			onClick={submitAndShowNext}
		// 		>Yes</Button>
				
		// 		<Button
		// 			variant="secondary"
		// 			className="modalCloseBtn"
		// 			onClick={toggle}
		// 		>No</Button>
		// 	</Modal.Footer>
		// </Modal>
			<Modal show={isOpen} size="md" centered contentClassName="mock-container">
			<Modal.Header style={{ padding: "0px" }} className="mock-popup-header">
				<div className="d-flex justify-content-end align-items-center p-2">
				<button onClick={toggle} className="modal-close-btn" >
					×
				</button>
				</div>
			</Modal.Header>
			<Modal.Body>
				<div className="d-flex gap-2 align-items-center mock-resource-text">
				<div className="d-flex justify-content-center align-items-center">
					<img
					src={InfoImage}
					alt="Information"
					style={{
						height: "40px",
						width: "30px",
						objectFit: "contain",
						display: "block",
					}}
					/>
				</div>{" "}Do you want to go to next Question?
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button
				color="secondary"
				className="mock-test-modal-button"
				onClick={submitAndShowNext}
				>
				Yes
				</Button>
				<Button
				color="secondary"
				className="mock-test-modal-button"
				onClick={toggle}
				>
				No
				</Button>
			</Modal.Footer>
			</Modal>		
	);
});

export default NextModal;